module.exports = __webpack_public_path__ + "img/w74.e02f24f0.svg";